export function validateEmail(email: string) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}
export function validateMobileNumber(mobileNumber: string) {
  const mobileRegex = /^[1-9]\d{9}$/;
  return mobileRegex.test(mobileNumber);
}
